import React from "react"
import { Form, Message } from "semantic-ui-react"
import BifrostButton from "../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../BifrostPageComponent/BifrostModal/BifrostModal"
import Loader from "../../BifrostPageComponent/Loader/Loader"
import { useTransferDeviceToOrgModal } from "../hooks/useTransferDeviceToOrgModal"

/**
 * This is a component for TransferDeviceToOrgModal which will be used to transfer device to another organization.
 * It is a reusable component. Depending on the page where it is used, it will have different procudures.
 * If the type is "device", it will transfer the device to another organization.
 * if the type is "org", it will transfer the device into the organization.
 * For the reseller admin user, it will transfer the device to another organization but can not transfer the device to their organization. The Button of the modal will be disabled.
 * The super admin user can transfer the device to any organization.
 * @param {Object} param0 props - type, refresh, device
 * @param {String} type - type of the modal (device or org)
 * @param {Function} refresh - function to refetch the data - on the device page, it will refetch the organization data, on the organization page, it will refetch the device data.
 * @param {Object} device - device object which will be transferred to another organization. This object will only be used on the device detail page.
 * @returns {React.Component} TransferDeviceToOrgModal
 */
const TransferDeviceToOrgModal = ({ type, refresh, device }) => {
	const { state, toggleModalHandler, handleSeslectItem, confirmMoveDevice, cancelMoveDevice, handleOKButtonClicked } = useTransferDeviceToOrgModal(type, refresh, device)

	return (
		<BifrostModal
			title={state.staticUIElement.title}
			open={state.open}
			setOpen={() => toggleModalHandler()}
			trigger={
				<BifrostButton size="medium" disabled={state.isDisabled}>
					{state.staticUIElement.title}
				</BifrostButton>
			}
			modalPage={
				<>
					{state.isError && <Message negative content={state.errorMessage} />}
					{state.isLoading && <Loader backgroundColor="white" inverted size="small" />}
					{state.isSuccess && <Message positive content="Moved the device successfully" />}
					{!state.isLoading && !state.isError && !state.isSuccess && (
						<>
							<Form>
								<Form.Dropdown
									fluid
									search
									selection
									loading={state.isLoadingOrg}
									noResultsMessage={state.staticUIElement.noResultsMessage}
									onChange={(e, data) => handleSeslectItem(e, data)}
									placeholder={state.isNotSelected ? "Please select a target" : state.staticUIElement.placeholder}
									options={state.data}
									error={state.isNotSelected}
								/>
							</Form>
							<Message>{state.staticUIElement.notification}</Message>
						</>
					)}
				</>
			}
			modalActions={
				<div style={{ display: "flex", justifyContent: "right" }}>
					{state.isError || state.isSuccess ? (
						<BifrostButton onClick={() => handleOKButtonClicked()}>OK</BifrostButton>
					) : (
						<>
							<BifrostButton onClick={() => confirmMoveDevice()}>Confirm</BifrostButton>
							<BifrostButton color="gray" onClick={() => cancelMoveDevice()}>
								Cancel
							</BifrostButton>
						</>
					)}
				</div>
			}
		/>
	)
}

export default TransferDeviceToOrgModal
